import React from 'react';
import { useLocation } from 'react-router-dom';
import './DiwaliFestive.css';

// Diwali 2026 is 8 Nov — effects show 25 Oct → 15 Nov and switch off automatically.
const START = new Date('2026-10-25T00:00:00+05:30');
const END = new Date('2026-11-16T00:00:00+05:30');
const HIDE_ON = ['/admin', '/hrm', '/crm', '/room', '/partner', '/training-note'];
const BULBS = 34;

const Lantern = ({ className, delay, size = 1 }) => (
  <div className={`dw-lantern ${className}`} style={{ animationDelay: delay, '--s': size }}>
    <span className="dw-lantern-cord" />
    <svg viewBox="0 0 60 96" className="dw-lantern-body" aria-hidden="true">
      <defs>
        <linearGradient id="lg-gold" x1="0" x2="1"><stop offset="0" stopColor="#8a5a14" /><stop offset=".5" stopColor="#f6d27a" /><stop offset="1" stopColor="#8a5a14" /></linearGradient>
        <radialGradient id="lg-core" cx=".5" cy=".55" r=".55"><stop offset="0" stopColor="#fff3c4" /><stop offset=".45" stopColor="#f59e0b" /><stop offset="1" stopColor="#9a3412" /></radialGradient>
      </defs>
      <rect x="22" y="2" width="16" height="6" rx="2" fill="url(#lg-gold)" />
      <path d="M30 8 L54 34 L30 74 L6 34 Z" fill="url(#lg-core)" stroke="url(#lg-gold)" strokeWidth="2.5" />
      <path d="M30 8 L30 74 M6 34 L54 34 M18 21 L42 21 M18 54 L42 54" stroke="url(#lg-gold)" strokeWidth="1.2" opacity=".8" />
      {[14, 22, 30, 38, 46].map((x) => <line key={x} x1={x} y1="76" x2={x} y2={88 + (x % 3)} stroke="#f6d27a" strokeWidth="1.4" strokeLinecap="round" />)}
    </svg>
    <span className="dw-lantern-glow" />
  </div>
);

const Diya = ({ delay, small }) => (
  <div className={`dw-diya ${small ? 'dw-diya-sm' : ''}`} style={{ animationDelay: delay }}>
    <span className="dw-flame"><span className="dw-flame-core" /></span>
    <span className="dw-flame-halo" />
    <svg viewBox="0 0 80 34" className="dw-bowl" aria-hidden="true">
      <defs><linearGradient id="dg-brass" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#fde68a" /><stop offset=".35" stopColor="#d4a03a" /><stop offset="1" stopColor="#7c4a0e" /></linearGradient></defs>
      <path d="M2 6 Q40 14 78 6 Q72 32 40 32 Q8 32 2 6Z" fill="url(#dg-brass)" />
      <path d="M2 6 Q40 14 78 6 Q76 10 40 12 Q4 10 2 6Z" fill="#fff7d6" opacity=".55" />
      <path d="M14 20 Q40 27 66 20" stroke="#fde68a" strokeWidth="1" fill="none" opacity=".7" />
    </svg>
  </div>
);

export const DiwaliFestive = () => {
  const { pathname } = useLocation();
  const now = new Date();
  if (now < START || now >= END || HIDE_ON.some((p) => pathname.startsWith(p))) return null;
  return (
    <div className="dw-layer" aria-hidden="true" data-testid="diwali-festive">
      <svg className="dw-string" viewBox="0 0 1000 40" preserveAspectRatio="none">
        <defs><linearGradient id="dw-wire" x1="0" x2="1"><stop offset="0" stopColor="#b8862b" /><stop offset=".5" stopColor="#f6d27a" /><stop offset="1" stopColor="#b8862b" /></linearGradient></defs>
        <path d="M0 1 Q 125 30 250 1 T 500 1 T 750 1 T 1000 1" fill="none" stroke="url(#dw-wire)" strokeWidth="1.2" />
      </svg>
      <div className="dw-bulbs">
        {Array.from({ length: BULBS }, (_, i) => {
          const x = (i + 0.5) / BULBS;
          const y = 1 + 27 * Math.abs(Math.sin(Math.PI * x * 4));
          return <span key={i} className="dw-bulb" style={{ left: `${x * 100}%`, top: `${y * 0.62}px`, animationDelay: `${(i * 0.12) % 2.4}s` }} />;
        })}
      </div>
      {pathname === '/' && <>
        <Lantern className="dw-lantern-l" delay="0s" />
        <Lantern className="dw-lantern-l2" delay="1.1s" size={0.72} />
        <Lantern className="dw-lantern-r" delay="0.6s" size={0.85} />
      </>}
      <div className="dw-diyas"><Diya delay="0s" small /><Diya delay="0.4s" /><Diya delay="0.8s" small /></div>
      {Array.from({ length: 14 }, (_, i) => (
        <span key={i} className="dw-bokeh" style={{ left: `${4 + ((i * 37) % 92)}%`, animationDelay: `${i * 1.7}s`, animationDuration: `${14 + (i % 5) * 3}s`, '--sz': `${6 + (i % 4) * 4}px` }} />
      ))}
    </div>
  );
};
